import { render, staticRenderFns } from "./transfferModal.vue?vue&type=template&id=31a28423&scoped=true&"
import script from "./transfferModal.vue?vue&type=script&lang=js&"
export * from "./transfferModal.vue?vue&type=script&lang=js&"
import style0 from "./transfferModal.vue?vue&type=style&index=0&id=31a28423&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a28423",
  null
  
)

export default component.exports